<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'NewsCenter',
          to: {
            name: 'NewsCenter'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'NewsCreate',
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增文章</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- Block 新增文章 -->
    <NewsCreateEdit></NewsCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import NewsCreateEdit from '@/views/E-4__News/c/NewsCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    NewsCreateEdit,
  },
  computed: {
    ...mapState('news', ['news']),
  },
  created() {
    this.setNews({});
  },
  methods: {
    ...mapActions('news', ['setNews', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'NewsCenter' });
    },
    saveHandler() {
      this.save(this.news).then(() => {
        this.$router.push({ name: 'NewsCenter' });
      });
    },
  },
};
</script>

<style></style>
